'use client';

import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { implantacaoStore } from '@/infrastructure/store/implantacaoStore';

export function useImplantacao() {
  return useStore(
    implantacaoStore,
    useShallow((s) => ({
      pendencias: s.pendencias,
      loading: s.loading,
      failed: s.failed,
      loadPendencias: s.loadPendencias,
    })),
  );
}
